import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

function list(params) {
  return request({
    url: ENDPOINT.ROLE_USERS,
    method: "get",
    params,
  });
}

async function show(id) {
  return await request({
    url: `${ENDPOINT.ROLE_USERS}/${id}`,
    method: "get",
  });
}

function create(data) {
  return request({
    url: ENDPOINT.ROLE_USERS,
    method: "post",
    data,
  });
}

function update(data) {
  return request({
    url: `${ENDPOINT.ROLE_USERS}/${data.id}`,
    method: "patch",
    data,
  });
}

function remove(data) {
  return request({
    url: `${ENDPOINT.ROLE_USERS}/${data.id}`,
    method: "delete",
    data,
  });
}

export default {
  list,
  show,
  create,
  update,
  remove,
};
